import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import api from "../api/axiosInstance";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import JSZip from "jszip";

function UserView() {
  const [searchParams] = useSearchParams();
  const RequestId = searchParams.get("id");
  const [product, setProduct] = useState(null); // State to hold product data
  const [errorMessage, setErrorMessage] = useState(null); // State for error handling

  useEffect(() => {
    if (RequestId) {
      fetchProductData(RequestId);
    }
  }, [RequestId]);

  const fetchProductData = (id) => {
    api
      .get('/request/frame/list', {
        params: { frame_id: id },
      })
      .then((res) => {
        if (res.data.status === "success") {
          setProduct(res.data.result); // Set the fetched product data
        } else {
          setErrorMessage("Failed to fetch product data");
        }
      })
      .catch((err) => {
        console.error("Product fetch error:", err);
        setErrorMessage("Failed to fetch product data");
      });
  };

  useEffect(() => {
    const pathname = window.location.pathname;
    if (pathname === "/user_view") {
      console.log("Adding classes to the body.");
      document.body.classList.remove("login-page");
      document.body.classList.add("sidebar-mini");
    }
  }, []);

  // Render loading or error message while fetching data
  if (!product && !errorMessage) {
    return <div>Loading...</div>;
  }

  // Render error message if fetch failed
  if (errorMessage) {
    return <div>{errorMessage}</div>;
  }
  const formatFileName = (fileName) => {
    const extension = fileName.split(".").pop();
    let baseName = fileName;

    if (fileName.length > 10) {
      baseName = fileName.substring(0, 6);
      return `${baseName}...${extension}`;
    } else {
      return fileName;
    }
  };

  const handleDownloadAll = async () => {
    try {
      const zip = new JSZip();
      const promises = [];

      // Iterate over each photo in product.photo_list
      product.photo_list.forEach((photo, index) => {
        // Create a fetch promise for each photo and add it to promises array
        const promise = fetch(photo.file_url)
          .then((response) => response.blob())
          .then((blob) => {
            // Add file to the zip archive with a dynamically generated name
            zip.file(`photo_${index}.jpg`, blob);
          })
          .catch((error) => {
            console.error(`Error fetching photo ${photo.file_url}:`, error);
          });

        promises.push(promise);
      });

      // Wait for all fetch requests to complete
      await Promise.all(promises);

      // Generate zip file asynchronously
      zip.generateAsync({ type: "blob" }).then((blob) => {
        // Create a temporary link element to trigger the download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "photos.zip";

        // Append the link to the DOM and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up: remove the link from the DOM
        document.body.removeChild(link);
      });
    } catch (error) {
      console.error("Error creating zip file:", error);
      // Handle error as needed
    }
  };

  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">
                  #{product._id} - {product.user_id.first_name}{" "}
                  <a href={`/user_edit?id=${product._id}`}>
                    <i
                      className="fa-solid fa-pen ml-2 f_sz16"
                      title="Edit User"
                    />
                  </a>
                  {/*<a href="#"><i class="fa-solid fa-trash-can ml-2 f_sz16" title="Delete User"></i></a>*/}
                </h1>
              </div>
              {/* /.col */}
              <div className="col-sm-6">
                <ol className="breadcrumb justify-content-end">
                  <li className="breadcrumb-item">
                    <a href="/users">
                      <i className="fa-solid fa-arrow-left-long mr-2" />
                      Back
                    </a>
                  </li>
                </ol>
              </div>
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card card-primary card-outline">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">Id</label>
                          <div className="col-12 col-md-8">{product._id}</div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">User</label>
                          <div className="col-12 col-md-8">
                            {product.user_id.first_name}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">Email</label>
                          <div className="col-12 col-md-8">
                            {product.user_id.email_address}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">Phone</label>
                          <div className="col-12 col-md-8">
                            +91{product.user_id.phone_number}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                            Request for
                          </label>
                          <div className="col-12 col-md-8">
                            {product.request_type}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                            No of Photos
                          </label>
                          <div className="col-12 col-md-8">
                            {product.photo_list.length}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">Type</label>
                          <div className="col-12 col-md-8">
                            {product.request_type === "frame"
                              ? product.frame_type
                              : product.album_type}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">Size</label>
                          <div className="col-12 col-md-8">
                          {product.request_type === "frame"
                              ? product.frame_size
                              : product.album_size}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                            Status
                          </label>
                          <div className="col-12 col-md-8">
                            <span className="badge badge-danger fwt_400 f_sz13">
                              {product.status === "not_started"
                                ? "Not Started"
                                : product.status === "in_progress"
                                ? "Inprogress"
                                : "Completed"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /.row */}
                    <div className="row mt-3">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="f_sz16 fwt_600">
                          Photos ({product.photo_list.length}){" "}
                          {/* <a className="btn btn-primary ml-3">
                            Download <i className="fa-solid fa-download ml-2" />
                          </a> */}
                          <button
                            className="btn btn-primary ml-3"
                            onClick={handleDownloadAll}
                          >
                            Download <i className="fa-solid fa-download ml-2" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      {product.photo_list.map((photo) => (
                        <div
                          key={photo._id}
                          className="col-6 col-sm-3 col-md-3 col-lg-2"
                        >
                          <div className="store_imgdiv mt-3">
                            <div className="storeimg">
                              <img
                                src={photo.file_url}
                                alt={photo.display_name}
                                border={0}
                              />
                            </div>
                            <div className="w-100 text-center">
                              {formatFileName(photo.display_name)}
                            </div>
                            {/* <div class="store_imgdel"><i class="fa-solid fa-xmark"></i></div> */}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </div>
        {/* /.content */}
      </div>

      <Footer />
    </div>
  );
}

export default UserView;
